module.exports = __webpack_public_path__ + "static/media/pattern.e85c36ee.png";